import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-common-mistakes-buying-ifp',
    templateUrl: './common-mistakes-buying-ifp.component.html',
    styleUrls: ['./common-mistakes-buying-ifp.component.scss']
})
export class CommonMistakesBuyingIfpComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titleService: Title,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Best Interactive Flat Panel for Schools | Buying Guide – Virsa');
        this.meta.updateTag({
            name: 'description',
            content: 'Planning to buy an Interactive Flat Panel for your school? Learn common buying mistakes and why schools across India trust Virsa for smart classroom solutions.'
        });
        this.meta.updateTag({
            name: 'keywords',
            content: 'Interactive Flat Panel for Schools, IFP for Schools India, Smart Classroom Solutions India, Best IFP for Schools, Smart Classroom Provider India, Digital Classroom India, Virsa IFP'
        });
    }

}
